import React, { useState } from "react";
import { Link } from "react-router-dom";
import DonutChart from "../../../../../../component/DonutChart";
import { useSelector, shallowEqual } from "react-redux";
import SelfAttendance from "../table/selfAttendance";

export const AttendanceSummaryMgt = ({ attendanceSummary }) => {
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [selectedAttendanceType, setSelectedAttendanceType] = useState("");
  const [selectedAttendanceDetails, setSelectedAttendanceDetails] = useState(
    []
  );

  const { attendance } = useSelector(
    (state) => ({
      attendance: state?.auth?.userAccess["Attendance"],
    }),
    shallowEqual
  );

  const isAttRequest = attendance?.find(
    (el) =>
      el?.componentName === "ReadAllAttendanceRequest" && el?.isResourceShow
  );

  const isAttCalendar = attendance?.find(
    (el) =>
      el?.componentName === "ReadAttendanceCalendar" && el?.isResourceShow
  );

  // Department API array return karti hai
const departmentAttendance = Array.isArray(attendanceSummary)
  ? attendanceSummary?.[0] || {}
  : attendanceSummary?.data?.[0] || attendanceSummary || {};

const departmentDetails = Array.isArray(
  departmentAttendance?.AttendanceDetails
)
  ? departmentAttendance.AttendanceDetails
  : [];

console.log("TOTAL DETAILS:", departmentDetails.length);

console.log(
  "LATE IN RECORDS:",
  departmentDetails.filter(
    (x) => x?.status === "P" && x?.isLateComing === 1
  )
);
  const attendanceFields = [
    { label: "Present", key: "On_Time" },
    { label: "On Time", key: "On_Time" },
    { label: "Late In", key: "LateIn" },
    { label: "Early Out", key: "EarlyOut" },
    { label: "Half Day", key: "Half_Day" },
    { label: "Absent", key: "Absent_Day" },
    { label: "On Leave", key: "On_Leave" },
  ];

  return (
    <div className="w-full bg-white rounded-lg">
      <div className="w-full text-xs px-3 py-2 flex flex-col h-full justify-between">

        <div className="w-full">
          <h6 className="font-bold mb-0 text-primary my-2">
            Today's Attendance
          </h6>

          <DonutChart
            data={
              attendanceSummary &&
              Object.keys(attendanceSummary).length > 0
                ? Object.entries(attendanceSummary)
                    .filter(
                      ([key]) =>
                        key !== "Id" &&
                        key !== "FirstName" 
                    )
                    .map(([key, value]) => ({
                      label: key?.replaceAll("_", " "),
                      value: value,
                    }))
                : []
            }

          onItemClick={(item) => {
  console.log("DONUT CLICK:", item);

  const details = Array.isArray(departmentDetails)
    ? departmentDetails
    : [];

  let filteredDetails = [];

  switch (item.label) {
    case "On Time":
      filteredDetails = details.filter(
        (x) =>
          x?.isOnTime === 1 &&
          x?.isHalfDay !== 1
      );
      break;

    case "LateIn":
      filteredDetails = details.filter(
        (x) => x?.isLateComing === 1
      );
      break;

    case "Early Out":
      filteredDetails = details.filter(
        (x) => x?.isEarlyGoing === 1
      );
      break;

    case "Half Day":
      filteredDetails = details.filter(
        (x) => x?.isHalfDay === 1
      );
      break;

    case "Absent Day":
      filteredDetails = details.filter(
        (x) =>
          x?.status?.toLowerCase()?.includes("absent")
      );
      break;

    case "On Leave":
      filteredDetails = details.filter(
        (x) =>
          x?.isOnLeave === 1 ||
          x?.isPartialLeave === 1
      );
      break;

    default:
      filteredDetails = [];
  }

  console.log("FILTERED DEPARTMENT DETAILS:", filteredDetails);

  setSelectedAttendanceType(item?.label);
  setSelectedAttendanceDetails(filteredDetails);
  setShowAttendanceModal(true);
}}
          />
        </div>

        <div className="grid grid-cols-2 text-sm gap-x-8 mt-5">
          {attendanceFields.map(({ label, key }) => (
            <div
              key={key}
              className="flex justify-between items-center"
            >
              <p className="text-black m-0">{label}</p>

              <p className="text-primary font-extrabold m-0">
                {departmentAttendance?.[key] || 0}
              </p>
            </div>
          ))}
        </div>

        <div className="font-size-xs font-semibold flex gap-4 items-end text-black mt-2 flex-wrap">

          <p className="m-0 underline">
            {isAttRequest ? (
              <Link to="/attendance_request/read-all-attendance-request">
                Attendance Request
              </Link>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Attendance Request
              </label>
            )}
          </p>

          <p className="m-0 underline">
            {isAttCalendar ? (
              <Link to="/attendance_calendar_team/read-attendance-calendar">
                Attendance Calendar
              </Link>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Attendance Calendar
              </label>
            )}
          </p>
        </div>
      </div>

      <SelfAttendance
        show={showAttendanceModal}
        onHide={() => {
          setShowAttendanceModal(false);
          setSelectedAttendanceDetails([]);
          setSelectedAttendanceType("");
        }}
        data={selectedAttendanceDetails}
        selectedType={selectedAttendanceType}
        isManagerView={true}
      />
    </div>
  );
};